import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import { useEffect, useState } from "react";
import Button from "src/components/Form/Button";
import Subheading from "src/components/Subheading";
import FormCheckbox from "src/components/Form/FormCheckbox";
import usePersistantState from "src/hooks/usePersistantState";



export default function JobAnalysisPage5({ handleStep, handleStepDown }) {

    const [EVC, setEVC] = usePersistantState("EVC", {
        "تعهد و تعلق سازمانی": {
            value: {},
            desc: ""
        },
        "نظم و انضباط و آراستگی ": {
            value: {},
            desc: ""
        },
        "رعایت شئونات محیط کار": {
            value: {},
            desc: ""
        },
        "روحیه همکاری ، مشارکت و حل تضاد": {
            value: {},
            desc: ""
        },
        "ارتباطات خوب، احترام به دیگران و حسن رفتار": {
            value: {},
            desc: ""
        },
    })

    const [KSA, setKSA] = usePersistantState("KSA", {
        "آشنایی با اصول و دانش مدیریتی ": {
            value: {},
            desc: ""
        },
        "آشنایی با خواص مواد و ملزومات": {
            value: {},
            desc: ""
        },
        "آشنایی با قوانین ، مقررات و آیین نامه های  مرتبط با شغل": {
            value: {},
            desc: ""
        },
        "آشنایی با مقررات، استاندارد ها و نظام های کیفیت": {
            value: {},
            desc: ""
        },
        "آشنایی و رعایت  اصول ایمنی و ارگونومی": {
            value: {},
            desc: ""
        },
        "آموزش‌پذیری و یادگیری ": {
            value: {},
            desc: ""
        },
        "بكارگیری تكنولوژی های نوین": {
            value: {},
            desc: ""
        },
        "تجزیه و تحلیل منطقی": {
            value: {},
            desc: ""
        },
        "توانایی مذاکره ، متقاعد سازی و اقناع دیگران": {
            value: {},
            desc: ""
        },
        "کسب مهارت های شغلی": {
            value: {},
            desc: ""
        },
        "مدیریت دانش و تجارب سازمانی": {
            value: {},
            desc: ""
        },
        "مستندسازی و مهارتهای اداری": {
            value: {},
            desc: ""
        },
    })


    const [PI, setPI] = usePersistantState("PI", {
        "رعایت  اصول ایمنی و ارگونومی": {
            value: {},
            desc: ""
        },
        "ارائه گزارش های تحلیلی": {
            value: {},
            desc: ""
        },
        "استفاده مؤثر از تجهیزات": {
            value: {},
            desc: ""
        },
        "انجام به موقع کار": {
            value: {},
            desc: ""
        },
        "انجام کار مطابق دستورالعمل و رویه ها": {
            value: {},
            desc: ""
        },
        "برنامه ریزی، هدف گذاری و مدیریت زمان": {
            value: {},
            desc: ""
        },
        "بکارگیری موثر ابزارهای فنی و تکنولوژیکی": {
            value: {},
            desc: ""
        },
        "بهره گیری موثر از منابع اطلاعاتی": {
            value: {},
            desc: ""
        },
        "پاسخگویی و مسئولیت پذیری": {
            value: {},
            desc: ""
        },
        "تصمیم سازی": {
            value: {},
            desc: ""
        },
        "کیفیت کار": {
            value: {},
            desc: ""
        },
        "مشارکت موثر در عملکرد واحد ": {
            value: {},
            desc: ""
        },
        "نظارت و کنترل": {
            value: {},
            desc: ""
        },
        "هدایت و رهبری تیم کاری": {
            value: {},
            desc: ""
        },
        "پیاده سازی مناسب استانداردها و نظامهای كیفیت": {
            value: {},
            desc: ""
        },
        "جانشین پروری ، توسعه و توانمند سازی تیم کاری": {
            value: {},
            desc: ""
        },
        "دقت عمل و تمرکز در کار": {
            value: {},
            desc: ""
        },
        "سازماندهی و تخصیص بهینه منابع": {
            value: {},
            desc: ""
        },
        "صرفه جویی در منابع": {
            value: {},
            desc: ""
        },
        "کمیت کار ، سرعت عمل و چابکی": {
            value: {},
            desc: ""
        },
    })
    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={6} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">



                <Subheading title="شاخص های رفتاری (EVC)" isFirst={true} />
                <FormCheckbox state={EVC} setState={setEVC} newButtonLabel="افزودن مورد جدید" />




                <Subheading title="شاخص های مبتنی بر شایستگی (KSA)" />
                <FormCheckbox state={KSA} setState={setKSA} newButtonLabel="افزودن مورد جدید" />





                <Subheading title="شاخص های عملکردی (PI)" />
                <FormCheckbox state={PI} setState={setPI} newButtonLabel="افزودن مورد جدید" />


                <div className="flex justify-center items-center relative mt-10 z-50">
                    <Button isPrevious={true} title="مرحله قبل" direction="center" handleClick={(event) => handleStepDown()} color="#f9b302" />
                    <Button title="ثبت اطلاعات و تکمیل فرم بعدی" direction="center" handleClick={(event) => handleStep()} />
                </div>
            </div>



        </PanelLayout>
    )
}